import { render, staticRenderFns } from "./ModalVerifyOTP.vue?vue&type=template&id=1104ae1a&"
import script from "./ModalVerifyOTP.vue?vue&type=script&lang=js&"
export * from "./ModalVerifyOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports